export const constants = {
	APP_TITLE_TEMPLATE: '%s | frachter',
	COOKIE_NAME_COLOR_SCHEME: 'color_scheme',
	COOKIE_NAME_SANDBOX_INSTALLATION: 'sandbox_installation',
	DEFAULT_ORGANIZATION_APP: 'quickship',
	HEADER_KEY_ORG_SLUG: 'x-org-slug',
	NOTIFICATION_ID_PRINTER_GONE: 'printer-gone',
	NOTIFICATION_REALTIME_TOKEN_FETCH_FAILED: 'realtime-token-fetch-failed',
	SEARCH_PARAM_NAME_LOGIN: 'login',
	// SESSION_STORAGE_KEY_ORGANIZATIONS: 'organizations',
	SEARCH_PARAM_NAME_URL_RECOVERY: 'next',
	STORAGE_KEY_ORGANIZATION_id: 'org_id',
} as const;
